import { createSelector } from '@reduxjs/toolkit';
import { getImmutableCompatible } from 'src/utils/immutableUtils';
import type { PopupSliceState } from './types';

const getState = (state): PopupSliceState =>
  getImmutableCompatible(state, 'popup');

export const selectCurrentPopup = createSelector(
  getState,
  (state) => state.current,
);

export const selectIsFetching = createSelector(
  selectCurrentPopup,
  (popup) => popup === 'fetching',
);

export const selectIsError = createSelector(
  selectCurrentPopup,
  (popup) => popup === 'error',
);
